import { trackEvent } from '@intercom/messenger-js-sdk';

export const useChatBot = () => {
  const triggerChatBot = ({ eventName }: { eventName?: string } = {}) => {
    trackEvent(eventName, { product: 'Perform' });
  };

  return {
    triggerChatBot,
  };
};
